export const hasValue = (val) => val !== null && val !== undefined && val !== "" && !(Array.isArray(val) && val.length === 0);

export const formatWithUnit = (val, unit, fallback = "-") => (hasValue(val) ? `${val} ${unit}` : fallback);
